<template>
  <div class="all-lb">
    <div class="Breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户收益排行榜</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="leaderboard-button">
      <div class="btn-margin">
        <el-radio-group @change="runkChange" v-model="radio" size="mini">
          <el-radio-button
            v-for="item in runkTypeData"
            :key="item.id"
            :label="item.id"
            >{{ item.name }}</el-radio-button
          >
        </el-radio-group>
      </div>
    </div>
    <div class="total-list">
      <div class="total-list-mgin">
        <div class="banner-tittle">
          <div class="select-tittle">{{ rankingTittle }}</div>
        </div>
        <div class="total-list-mine">
          <div class="leaderboard">
            <div class="mine-leaderboard">
              <div class="lead-box" v-show="runkShow">
                <div class="runk-left">
                  <div class="ranking">
                    <div class="ranking-m">
                      {{ myRunk }}
                    </div>
                  </div>
                  <div class="user">
                    <div class="user-img" @click="myUserClick()">
                      <img class="head-portrait" :src="myAvatar" alt="" />
                      <img class="vip" :src="myImgUrl" alt="" />
                    </div>
                    <div class="user-name">
                      <span>{{ myUserName }}</span>
                      <div class="motto">{{ myAbout }}</div>
                    </div>
                  </div>
                </div>

                <div class="price">
                  <span>{{
                    this.userreType == 'mec' ||
                    this.userreType == 'qec' ||
                    this.userreType == 'aec'
                      ? myItem + '%'
                      : '$' + myItem
                  }}</span>
                </div>
              </div>
              <div class="lead-box-error" v-show="!runkShow">
                <span>{{ myMsg }}</span>
              </div>
            </div>
            <div class="top-leaderboard">
              <el-table :data="userresData" border style="width: 100%">
                <el-table-column
                  type="index"
                  label=""
                  class="ranking"
                  width="160"
                >
                  <template class="ranking" slot-scope="scope">
                    <div class="top">
                      <div v-if="scope.row.top == 1" class="topNo1">
                        TOP{{ scope.row.top }}
                      </div>
                      <div v-if="scope.row.top == 2" class="topNo2">
                        TOP{{ scope.row.top }}
                      </div>
                      <div v-if="scope.row.top == 3" class="topNo3">
                        TOP{{ scope.row.top }}
                      </div>
                      <div class="top-num">TOP{{ scope.row.top }}</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="姓名" width="714">
                  <template slot-scope="scope">
                    <div class="user" @click="userClick(scope.row.uuid)">
                      <div class="user-img">
                        <img
                          class="head-portrait"
                          :src="scope.row.avatar"
                          alt=""
                        />
                        <img
                          v-show="scope.row.imgUrl !== ''"
                          class="vip"
                          :src="scope.row.imgUrl"
                          alt=""
                        />
                      </div>
                      <div class="user-name">
                        <span
                          v-if="
                            scope.row.top == 1 ||
                            scope.row.top == 2 ||
                            scope.row.top == 3
                          "
                          class="no1"
                          >{{ scope.row.userName }}</span
                        >
                        <span v-else class="no">{{ scope.row.userName }}</span>
                        <div
                          v-if="
                            scope.row.top == 1 ||
                            scope.row.top == 2 ||
                            scope.row.top == 3
                          "
                          class="motto1"
                        >
                          {{ scope.row.motto }}
                        </div>
                        <div v-else class="motto">
                          {{ scope.row.motto }}
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="price" label="价格" width="244">
                  <template slot-scope="scope">
                    <div
                      v-if="
                        scope.row.top == 1 ||
                        scope.row.top == 2 ||
                        scope.row.top == 3
                      "
                      class="price1"
                    >
                      <span>{{
                        scope.row.userreType == 'mec' ||
                        scope.row.userreType == 'qec' ||
                        scope.row.userreType == 'aec'
                          ? scope.row.price + '%'
                          : '$' + scope.row.price
                      }}</span>
                    </div>
                    <div class="price">
                      <span>{{
                        scope.row.userreType == 'mec' ||
                        scope.row.userreType == 'qec' ||
                        scope.row.userreType == 'aec'
                          ? scope.row.price + '%'
                          : '$' + scope.row.price
                      }}</span>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pageParams.currentPage"
        background
        layout="sizes, prev, pager, next"
        :page-count="pageParams.pageCount"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="pageParams.pageSize"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getUserAsset } from '../api/User';
import { getRunkingList, getMyrank } from '@/api/Home.js';
export default {
  name: 'AllleaderBoard',
  data() {
    return {
      runkTypeData: [
        {
          id: 'me',
          name: '月收益',
        },
        {
          id: 'mec',
          name: '月收益率',
        },
        {
          id: 'qe',
          name: '季度收益',
        },
        {
          id: 'qec',
          name: '季度收益率',
        },
        {
          id: 'ae',
          name: '总收益',
        },
        {
          id: 'aec',
          name: '总收益率',
        },
        {
          id: 'aa',
          name: '总资产',
        },
      ],
      userresData: [],
      radio: 'me',
      radioName: {
        me: '月收益',
        mec: '月收益率',
        qe: '季度收益',
        qec: '季度收益率',
        ae: '总收益',
        aec: '总收益率',
        aa: '总资产',
      },
      rankingTittle: '',
      userreType: '',
      pageParams: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
        pageCount: 0,
        currentPage: 1,
      },
      accountId: '',
      myRunk: '',
      myUserName: '',
      myItem: '',
      myAvatar: ' ',
      myUuid: '',
      myVipName: '',
      myAbout: '',
      myImgUrl: ' ',
      runkShow: false,
      imgUrl: '',
      myMsg: '',
    };
  },
  watch: {},
  async created() {
    await this.findMyRunk();
    await this.getRunkData();
  },
  mounted() {},
  methods: {
    //小数点后面不足4位数补
    formatnumber(value, num) {
      var a, b, c, i;
      a = value.toString();
      b = a.indexOf('.');
      c = a.length;
      if (num == 0) {
        if (b != -1) {
          a = a.substring(0, b);
        }
      } else {
        //如果没有小数点
        if (b == -1) {
          a = a + '.';
          for (i = 1; i <= num; i++) {
            a = a + '0';
          }
        } else {
          //有小数点，超出位数自动截取，否则补0
          a = a.substring(0, b + num + 1);
          for (i = c; i <= b + num; i++) {
            a = a + '0';
          }
        }
      }
      return a;
    },
    //千分位处理
    formatNum(strNum) {
      if (strNum.length <= 3) {
        return strNum;
      }
      if (!/^(\+|-)?(\d+)(\.\d+)?$/.test(strNum)) {
        return strNum;
      }
      var a = RegExp.$1,
        b = RegExp.$2,
        c = RegExp.$3;
      var re = new RegExp();
      re.compile('(\\d)(\\d{3})(,|$)');
      while (re.test(b)) {
        b = b.replace(re, '$1,$2$3');
      }
      return a + '' + b + '' + c;
    },
    myUserClick() {
      this.$router.replace({
        path: '/User',
      });
    },
    //排行榜点击跳转用户详情
    async userClick(id) {
      //console.log(id);
      let params = {
        targetUUID: id,
        accountId: this.accountId,
      };
      const { data: res } = await getUserAsset(params);
      let userName = res.data.user.userName;
      if (res.code == 10001 || res.code == 10006) {
        this.$alert(res.msg, '提示', {
          customClass: 'permissions_a_alert',
        });
        return;
      }
      this.$router.replace({
        path: '/User',
        query: {
          targetUUID: id,
          accountId: this.accountId,
          userName: userName,
        },
      });
    },
    //排行榜查询类型筛选
    runkChange(value) {
      this.radio = value;
      this.userresData = [];
      this.pageParams.currentPage = 1;
      this.pageParams.pageIndex = 1;
      this.getRunkData();
      this.findMyRunk();
    },
    // //获取排行榜全部数据
    async getRunkData() {
      let params = {
        queryType: this.radio,
        pageIndex: this.pageParams.pageIndex,
        pageSize: this.pageParams.pageSize,
      };
      const { data: res } = await getRunkingList(params);
      //console.log('排行榜', res.pageCount);
      this.pageParams.pageCount = res.pageCount;
      this.pageParams.pageIndex = res.pageIndex;
      let userres = res.data;
      userres.forEach((item) => {
        this.userreType = this.radio;
        const userresObj = {
          top: item.rank,
          avatar: item.user.avatar,
          userName: item.user.userName,
          price: this.formatNum(item.item),
          vipName: item.user.vipName,
          motto: item.user.about,
          userreType: this.userreType,
          uuid: item.user.uuid,
          imgUrl: this.imgUrl,
        };
        //console.log(userresObj.motto);
        this.userresData.push(userresObj);
      });

      this.userresData.forEach((item) => {
        var text = item.vipName;
        //console.log('text', text);
        if (text == null) {
          item.imgUrl = '';
        } else {
          switch (text) {
            // case '高级会员V1':
            //   item.imgUrl = require('@/assets/img/rtaLogo/V1.svg');
            //   break;
            // case '高级会员V2':
            //   item.imgUrl = require('@/assets/img/rtaLogo/V2.svg');
            //   break;
            // case '超级会员':
            //   item.imgUrl = require('@/assets/img/rtaLogo/SVIP.svg');
            //   break;
            case 'A1':
              item.imgUrl = require('@/assets/img/rtaLogo/A1.svg');
              break;
            case 'A2':
              item.imgUrl = require('@/assets/img/rtaLogo/A2.svg');
              break;
            case 'A3':
              item.imgUrl = require('@/assets/img/rtaLogo/A3.svg');
              break;
            case 'A4':
              item.imgUrl = require('@/assets/img/rtaLogo/A4.svg');
              break;
            case 'A5':
              item.imgUrl = require('@/assets/img/rtaLogo/A5.svg');
              break;
            case 'A6':
              item.imgUrl = require('@/assets/img/rtaLogo/A6.svg');
              break;
            case 'A7':
              item.imgUrl = require('@/assets/img/rtaLogo/A7.svg');
              break;
            case 'A8':
              item.imgUrl = require('@/assets/img/rtaLogo/A8.svg');
              break;
            case 'A9':
              item.imgUrl = require('@/assets/img/rtaLogo/A9.svg');
              break;
          }
        }
      });
      //获取收益筛选类型标题
      let radioObj = this.radioName;
      //console.log(this.radio);
      let key = this.radio;
      this.rankingTittle = radioObj[key];
      //console.log(this.rankingTittle)
    },
    //获取我的排名全部数据
    async findMyRunk() {
      const { data: res } = await getMyrank({
        queryType: this.radio,
      });
      if (res.msg === '暂无您的排名') {
        this.runkShow = false;
        this.myMsg = res.msg;
      } else if (res.code === 10006) {
        this.runkShow = false;
        this.myMsg = res.msg;
      } else {
        this.runkShow = true;
        let myRunks = res.data;
        //console.log('我的排名数据', myRunks);
        this.myRunk = myRunks.rank;
        this.myUserName = myRunks.user.userName;
        this.myItem = this.formatNum(myRunks.item);
        this.myAvatar = myRunks.user.avatar;
        this.myVipName = myRunks.user.vipName;
        this.myAbout = myRunks.user.about;
        this.myUuid = myRunks.user.uuid;
        // console.log(this.myImgUrl);
        if (this.myVipName == null) {
          this.myImgUrl = '';
        } else {
          switch (this.myVipName) {
            // case '高级会员V1':
            //   this.myImgUrl = require('@/assets/img/rtaLogo/V1.svg');
            //   break;
            // case '高级会员V2':
            //   this.myImgUrl = require('@/assets/img/rtaLogo/V2.svg');
            //   break;
            // case '超级会员':
            //   this.myImgUrl = require('@/assets/img/rtaLogo/SVIP.svg');
            //   break;
            case 'A1':
              this.myImgUrl = require('@/assets/img/rtaLogo/A1.svg');
              break;
            case 'A2':
              this.myImgUrl = require('@/assets/img/rtaLogo/A2.svg');
              break;
            case 'A3':
              this.myImgUrl = require('@/assets/img/rtaLogo/A3.svg');
              break;
            case 'A4':
              this.myImgUrl = require('@/assets/img/rtaLogo/A4.svg');
              break;
            case 'A5':
              this.myImgUrl = require('@/assets/img/rtaLogo/A5.svg');
              break;
            case 'A6':
              this.myImgUrl = require('@/assets/img/rtaLogo/A6.svg');
              break;
            case 'A7':
              this.myImgUrl = require('@/assets/img/rtaLogo/A7.svg');
              break;
            case 'A8':
              this.myImgUrl = require('@/assets/img/rtaLogo/A8.svg');
              break;
            case 'A9':
              this.myImgUrl = require('@/assets/img/rtaLogo/A9.svg');
              break;
          }
        }
      }
    },
    // 每页显示的记录数切换事件
    handleSizeChange(val) {
      this.userresData = [];
      this.pageParams.pageSize = val;
      this.getRunkData();

      // console.log('每页及记录-->', this.pageParams.pageSize);
    },
    // 切换页码事件
    handleCurrentChange(val) {
      this.userresData = [];
      this.pageParams.pageIndex = val;
      this.getRunkData();

      //console.log('当前页码：', val);
    },
  },
};
</script>

<style lang="scss">
.all-lb {
  width: 1200px;
  margin: 0 auto;
  //text-align: center;
  margin-top: 40px !important;
  display: flex;
  flex-direction: column;
  .Breadcrumb {
    .el-breadcrumb {
      .el-breadcrumb__item {
        .is-link {
          color: rgba(140, 140, 140, 1) !important;
        }
        .el-breadcrumb__inner {
          color: rgba(209, 212, 220, 1);
          font-size: 14px;
          font-family: MicrosoftYaHei;
          line-height: 22px;
        }
        .el-breadcrumb__separator {
          font-size: 10px;
        }
      }
    }
  }
  .leaderboard-button {
    margin-top: 56px;

    width: 100%;
    .btn-margin {
      float: right !important;
      display: flex;
      margin: 0 12px;
      .el-radio-group {
        width: 100%;
        display: flex;
        flex-wrap: nowrap !important;
        justify-content: space-between;
        flex-wrap: wrap;
        .el-radio-button {
          width: 100%;
          height: 40px;
          margin-left: 0px !important;
          padding: 0 0;
          border-radius: 4px !important;
          .el-radio-button__inner {
            background: rgba(159, 159, 159, 0.1);
            border-radius: 4px !important;
            border: none;
            padding: 11px 20px 10px 20px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #d1d4dc;
            line-height: 19px;
            margin-left: 12px;
          }
          .el-radio-button__inner:focus {
            background: rgba(159, 159, 159, 0.1);
            border-bottom: none;
          }
          .el-radio-button__orig-radio:checked + .el-radio-button__inner {
            border-radius: 4px !important;
            background: #edbd88;
            color: #33353e;
            border: none;
          }
          .el-radio-button__orig-radio:checked + .el-radio-button__inner {
            border-color: none;
            -webkit-box-shadow: none;
            box-shadow: none;
          }
        }
      }
      // .el-button {
      //   background: rgba(159, 159, 159, 0.1);
      //   border: none;
      //   padding: 10px 20px;
      //   border-radius: 4px;
      //   span {
      //     font-size: 14px;
      //     font-family: MicrosoftYaHei;
      //     color: #d1d4dc;
      //     line-height: 19px;
      //   }
      // }
      // .el-button:hover {
      //   background: #edbd88;
      //   span {
      //     color: #33353e !important;
      //   }
      // }
      // .el-button:focus {
      //   background: #edbd88;
      //   span {
      //     color: #33353e !important;
      //   }
      // }
    }
  }
  .total-list {
    width: 100%;
    height: 100%;
    background: rgba(159, 159, 159, 0.1);
    margin-top: 20px;
    border-radius: 8px !important;
    .total-list-mgin {
      padding: 40px 40px 0 40px !important;

      .banner-tittle {
        // border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        .select-tittle {
          margin-bottom: 32px;
          font-size: 32px;
          font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
          font-weight: bold;
          color: #e6be8f;
          line-height: 42px;
          text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
        }
        .select-time {
          margin-top: 12px;
          span {
            font-size: 13px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #999999;
            line-height: 15px;
          }
        }
      }
      .total-list-mine {
        .leaderboard {
          width: 1120px;
          height: 100%;

          border-radius: 11px;
          .mine-leaderboard {
            //border-bottom: 1px solid rgba(0, 0, 0, 0.1);
            .lead-box-error {
              width: 1120px;
              height: 96px;
              background: #33353e;
              box-shadow: 0px 2px 19px -4px rgba(0, 0, 0, 0.3),
                0px 2px 4px 0px rgba(0, 0, 0, 0.2),
                0px 2px 4px 0px rgba(0, 0, 0, 0.2);
              border-radius: 8px;
              margin: 8px 12px 50px 0 !important;
              display: flex;
              justify-content: center;
              span {
                height: 96px;
                line-height: 96px;
                text-align: center;
                margin: 0 auto;
                font-size: 20px;
                font-family: MicrosoftYaHei;
              }
            }
            .lead-box {
              width: 100%;
              height: 96px;
              background: #33353e;
              box-shadow: 0px 2px 19px -4px rgba(0, 0, 0, 0.3),
                0px 2px 4px 0px rgba(0, 0, 0, 0.2),
                0px 2px 4px 0px rgba(0, 0, 0, 0.2);
              border-radius: 4px;
              margin: 40px 0 50px 0;
              display: flex;
              .runk-left {
                width: 100%;
                display: flex;
                .ranking {
                  width: 120px;
                  height: 48px;
                  background: linear-gradient(
                    270deg,
                    rgba(51, 53, 62, 0) 0%,
                    #666666 150%
                  );
                  //border-radius: 0px 24px 24px 0px;
                  margin-top: 24px;
                  .ranking-m {
                    margin: 10px 20px;
                    width: 80px;
                    height: 28px;
                    font-size: 24px;
                    font-family: Roboto-BlackItalic, Roboto;
                    font-weight: bolder;
                    color: #ffffff;
                    line-height: 28px;
                    font-style: italic;
                    text-align: center;
                  }
                }
                .user {
                  margin-left: 42px !important;
                  display: flex;
                  width: 100%;
                  .user-img {
                    margin: 20px 0px 20px 0;
                    position: relative;
                    .head-portrait {
                      width: 56px;
                      height: 56px;
                      border-radius: 50%;
                      border: 1px solid #ffffff;
                    }
                    .vip {
                      width: 56px;
                      height: 23px;
                      position: absolute;
                      top: 35px;
                      right: 2px;
                    }
                  }
                  .user-name {
                    margin: 28px 0 28px 12px;
                    display: flex;
                    flex-direction: column;
                    span {
                      height: 21px;
                      font-size: 18px;
                      font-family: Roboto-Medium, Roboto;
                      font-weight: 500;
                      color: #d1d4dc;
                      line-height: 21px;
                    }
                    .motto {
                      margin-top: 4px;
                      width: 100%;
                      height: 18px;
                      font-size: 13px;
                      font-family: Roboto-Regular, Roboto;
                      font-weight: 400;
                      color: rgba(255, 255, 255, 0.7);
                      line-height: 15px;
                    }
                  }
                }
              }

              .price {
                font-size: 24px;
                font-family: Roboto-BoldItalic, Roboto;
                font-weight: normal;
                color: #d1d4dc;
                line-height: 28px;
                margin: 34px 64px 34px 0;
                display: flex;
                font-style: italic;
                span {
                  font-family: Roboto-BoldItalic, Roboto;
                }
              }
            }
          }
          .top-leaderboard {
            display: flex;
            flex-direction: column;
            .el-table {
              background-color: transparent;
              .el-table__header {
                display: none;
              }
              .el-table__expanded-cell {
                background-color: transparent !important;
              }
              .el-table__body {
                width: 100% !important;
              }

              tr {
                background-color: transparent;
                td {
                  border-top: 1px solid rgba(0, 0, 0, 0.1);
                  line-height: 71px;
                  padding: 0px;
                  .cell {
                    margin: 0px !important;
                    padding: 0px;
                    line-height: 35px;
                    height: 96px;
                  }

                  .top {
                    .topNo1 {
                      margin: 34px 0 34px 40px;
                      width: 100% !important;
                      height: 28px;
                      font-size: 24px;
                      font-family: Roboto-BlackItalic, Roboto;
                      font-weight: bolder;
                      color: #edbd88;
                      line-height: 28px;
                      font-style: italic;
                    }
                    .topNo2 {
                      margin: 34px 0 34px 40px;
                      width: 100% !important;
                      height: 28px;
                      font-size: 24px;
                      font-family: Roboto-BlackItalic, Roboto;
                      font-weight: bolder;
                      color: #e6bf60;
                      line-height: 28px;
                      font-style: italic;
                    }
                    .topNo3 {
                      margin: 34px 0 34px 40px;
                      width: 100% !important;
                      height: 28px;
                      font-size: 24px;
                      font-family: Roboto-BlackItalic, Roboto;
                      font-weight: bolder;
                      color: #fedb97;
                      line-height: 28px;
                      font-style: italic;
                    }
                    .top-num {
                      margin: 34px 0 34px 40px;
                      width: 100% !important;
                      height: 28px;
                      font-size: 24px;
                      font-family: Roboto-BlackItalic, Roboto;
                      font-weight: bolder;
                      color: #ffffff;
                      line-height: 28px;
                      font-style: italic;
                    }
                  }
                  .user {
                    display: flex;
                    .user-img {
                      margin: 20px 0px 20px 0;
                      position: relative;
                      .head-portrait {
                        width: 56px;
                        height: 56px;
                        border-radius: 50%;
                        border: 1px solid #ffffff;
                      }
                      .vip {
                        width: 56px;
                        height: 23px;
                        position: absolute;
                        top: 35px;
                        right: 2px;
                      }
                    }
                    .user-name {
                      margin: 28px 0 28px 12px;
                      display: flex;
                      flex-direction: column;
                      .no1 {
                        height: 21px;
                        font-size: 18px;
                        font-family: Roboto-Medium, Roboto;
                        font-weight: 500;
                        line-height: 21px;
                        color: rgba(237, 189, 136, 1) !important;
                      }
                      .no {
                        height: 21px;
                        font-size: 18px;
                        font-family: Roboto-Medium, Roboto;
                        font-weight: 500;
                        color: #d1d4dc;
                        line-height: 21px;
                      }
                      span {
                        height: 21px;
                        font-size: 18px;
                        font-family: Roboto-Medium, Roboto;
                        font-weight: 500;
                        color: #d1d4dc;
                        line-height: 21px;
                      }
                      .motto1 {
                        margin-top: 4px;
                        width: 100%;
                        height: 18px;
                        font-size: 13px;
                        font-family: Roboto-Regular, Roboto;
                        font-weight: 400;
                        color: rgba(237, 189, 136, 0.7);
                        line-height: 15px;
                      }
                      .motto {
                        margin-top: 4px;
                        width: 100%;
                        height: 18px;
                        font-size: 13px;
                        font-family: Roboto-Regular, Roboto;
                        font-weight: 400;
                        color: rgba(255, 255, 255, 0.7);
                        line-height: 15px;
                      }
                    }
                  }
                  .price1 {
                    font-size: 24px;
                    font-family: Roboto-BoldItalic, Roboto;
                    font-weight: normal;
                    color: rgba(237, 189, 136, 1);
                    line-height: 28px;
                    margin: 34px 64px 34px 0;
                    display: flex;
                    font-style: italic;
                    justify-content: flex-end;
                    span {
                      font-family: Roboto-BoldItalic, Roboto;
                    }
                  }
                  .price {
                    font-size: 24px;
                    font-family: Roboto-BoldItalic, Roboto;
                    font-weight: normal;
                    color: #d1d4dc;
                    line-height: 28px;
                    margin: 34px 64px 34px 0;
                    display: flex;
                    font-style: italic;
                    justify-content: flex-end;
                    span {
                      font-family: Roboto-BoldItalic, Roboto;
                    }
                  }
                }
              }
            }
            .el-table--enable-row-hover .el-table__body tr:hover > td {
              background: rgba(255, 255, 255, 0.1) !important;
              color: #33353e;
            }
            .el-table--enable-row-transition .el-table__body td,
            .el-table .cell {
              background-color: transparent;
            }
          }
        }
      }
    }
  }
  .pagination {
    margin: 40px 0 40px 0 !important;
    text-align: center;
    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      margin: 0 5px;
      background-color: rgba(61, 63, 72, 1) !important;
      color: #d1d4dc;
      min-width: 32px;
      min-height: 32px;
      border-radius: 2px;
    }
    .el-pagination {
      .el-pagination__sizes {
        .el-select {
          .el-input {
            .el-input__inner {
              height: 32px;
              border: none !important;
              background-color: rgba(61, 63, 72, 1) !important;
              color: #d1d4dc;
            }
          }
        }
      }
      .el-pager {
        li {
          padding: 4px 4px;
        }
      }
      .el-pager li:not(.disabled):hover {
        color: rgba(51, 53, 62, 1) !important;
        background: #edbd88 !important;
      }
      .el-pager li:not(.disabled).active {
        color: rgba(51, 53, 62, 1) !important;
        background: #edbd88 !important;
      }
    }
  }
}
.permissions_a_alert {
  .el-message-box__content {
    padding: 0 22px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AllleaderBoard.vue